import React from "react";
import PropTypes from "prop-types";
import UploadFilesPanel from "../components/carousel/library/UploadFilesPanel.jsx";
import MyFilesPanel from "../components/carousel/library/MyFilesPanel.jsx";
import OrgFilesPanel from "../components/carousel/library/OrgFilesPanel.jsx";
import BrandPanel from "../components/carousel/library/BrandPanel.jsx";
// TODO: Deprecated — AI sidebar panelleri kaldırılıyor, yerini modal popup'lar alıyor.
// import ImgTextToImageComponent from "../components/external_provider/file_modal/APIProviders/providers/imgTextToImageComponent";
// import SoundTextToSpeechComponent from "../components/external_provider/file_modal/APIProviders/providers/SoundTextToSpeechComponent";
// import AvatarTextToSpeechComponent from "../components/external_provider/file_modal/APIProviders/providers/AvatarTextToSpeechComponent";
import ImgTextToImageComponent from "../components/external_provider/file_modal/APIProviders/providers/imgTextToImageComponent";
import SoundTextToSpeechComponent from "../components/external_provider/file_modal/APIProviders/providers/SoundTextToSpeechComponent";
import AvatarTextToSpeechComponent from "../components/external_provider/file_modal/APIProviders/providers/AvatarTextToSpeechComponent";
import IconsPanel from "../components/carousel/library/IconsPanel";
import AnimationsPanel from "../components/carousel/library/AnimationsPanel";
import CharactersPanel from "../components/carousel/library/CharactersPanel";
import YoutubePanel from "../components/carousel/library/YoutubePanel";
import FlickrPanel from "../components/carousel/library/FlickrPanel";
import EuropeanaPanel from "../components/carousel/library/EuropeanaPanel";
import SceneAudioPanel from "../components/carousel/audio/SceneAudioPanel.jsx";
import DocumentSummaryPanel from "../components/carousel/audio/DocumentSummaryPanel.jsx";
import DocumentTitlesPanel from "../components/carousel/audio/DocumentTitlesPanel.jsx";
import OutlinePanel from "../components/carousel/audio/OutlinePanel.jsx";
import MindmapPanel from "../components/carousel/audio/MindmapPanel.jsx";
import NarrationTextsPanel from "../components/carousel/audio/NarrationTextsPanel.jsx";

const LibraryPanels = ({
  libraryCategory,
  isClm,
  aiPanel,
  filesUploaded,
  uploadFunction,
  onNavItemsAdded,
  onIndexSelected,
  onNavItemSelected,
  navItemsIds,
  navItems,
  navItemSelected,
  containedViews,
  containedViewSelected,
  boxes,
  boxSelected,
  pluginToolbars,
  fileModalResult,
  onAddBox,
  onReturnToLayers,
  onSetLibraryCategory,
  onReplacePluginFile,
  onShowServerModal,
  ttiGenerateImageFile,
  ttsGenerateSoundFile,
  baseUrl,
  trainingId,
  onNarrationSelect,
  onNarrationDelete,
  onSceneOpen,
  onBoxAdded,
}) => {
  const handleAddBoxAndClose = (
    ids,
    draggable,
    resizable,
    content,
    style,
    state,
    structure,
    initialParams
  ) => {
    onAddBox(ids, draggable, resizable, content, style, state, structure, initialParams);
    onReturnToLayers();
  };

  const handleAddBox = (...args) => onAddBox(...args);

  const handleReplaceSelected = (name, url) => {
    const replaceId = fileModalResult?.id;
    if (!replaceId || !url) return;

    const sourceMarker =
      { "My Files": "MyFiles", "Organization Files": "OrgFiles" }[libraryCategory] ||
      libraryCategory;

    onReplacePluginFile(replaceId, url, sourceMarker);
    onReturnToLayers();
    onSetLibraryCategory(null);
  };

  if (libraryCategory === "Upload Files") {
    return (
      <UploadFilesPanel
        isClm={isClm}
        filesUploaded={filesUploaded}
        uploadFunction={uploadFunction}
        onNavItemsAdded={onNavItemsAdded}
        onIndexSelected={onIndexSelected}
        onNavItemSelected={onNavItemSelected}
        navItemsIds={navItemsIds}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxes={boxes}
        fileModalResult={fileModalResult}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
        onBoxAdded={(...args) => {
          // Panel stays open: the multi-file queue lets the user add several
          // uploads to the scene one after another (or all at once).
          onAddBox(...args);
        }}
      />
    );
  }

  if (libraryCategory === "My Files") {
    return (
      <MyFilesPanel
        isClm={isClm}
        filesUploaded={filesUploaded}
        onNavItemsAdded={onNavItemsAdded}
        onIndexSelected={onIndexSelected}
        onNavItemSelected={onNavItemSelected}
        navItemsIds={navItemsIds}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxes={boxes}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        fileModalResult={fileModalResult}
        onBoxAdded={handleAddBox}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  if (libraryCategory === "Organization Files") {
    return (
      <OrgFilesPanel
        isClm={isClm}
        onNavItemsAdded={onNavItemsAdded}
        onIndexSelected={onIndexSelected}
        onNavItemSelected={onNavItemSelected}
        navItemsIds={navItemsIds}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxes={boxes}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        fileModalResult={fileModalResult}
        onBoxAdded={handleAddBox}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  if (libraryCategory === "Brand") {
    return (
      <BrandPanel
        isClm={isClm}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxes={boxes}
        pluginToolbars={pluginToolbars}
        onBoxAdded={handleAddBox}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  // TODO: Deprecated — aiPanel="images", "sounds", "avatars" sidebar modları kaldırılıyor.
  // Yerini EditorNavBar üzerindeki modal popup'lar aldi
  /*
  if (aiPanel === "images") {
    return (
      <ImgTextToImageComponent
        inSidebar
        onElementSelected={() => {}}
        ttiGenerateImageFile={ttiGenerateImageFile}
        onServerModal={onShowServerModal}
      />
    );
  }

  if (aiPanel === "sounds") {
    return (
      <SoundTextToSpeechComponent
        onElementSelected={() => {}}
        ttsGenerateSoundFile={ttsGenerateSoundFile}
        onServerModal={onShowServerModal}
      />
    );
  }

  if (aiPanel === "avatars") {
    return (
      <AvatarTextToSpeechComponent
        onElementSelected={() => {}}
        onServerModal={onShowServerModal}
        navItemSelected={navItemSelected}
      />
    );
  }
  */

  if (aiPanel === "scene-sounds") {
    return (
      <SceneAudioPanel
        navItems={navItems}
        navItemsIds={navItemsIds}
        navItemSelected={navItemSelected}
        boxes={boxes}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        uploadFunction={uploadFunction}
        baseUrl={baseUrl}
        trainingId={trainingId}
        onNarrationSelect={onNarrationSelect}
        onNarrationDelete={onNarrationDelete}
        onSceneOpen={onSceneOpen}
      />
    );
  }

  if (aiPanel === "document-summary") {
    return (
      <DocumentSummaryPanel
        baseUrl={baseUrl}
        trainingId={trainingId}
        navItems={navItems}
        navItemsIds={navItemsIds}
      />
    );
  }

  if (aiPanel === "document-titles") {
    return <DocumentTitlesPanel />;
  }

  if (aiPanel === "outline") {
    return <OutlinePanel baseUrl={baseUrl} trainingId={trainingId} />;
  }

  if (aiPanel === "mindmap") {
    return <MindmapPanel />;
  }

  if (aiPanel === "narration-texts") {
    return (
      <NarrationTextsPanel
        navItems={navItems}
        navItemsIds={navItemsIds}
        navItemSelected={navItemSelected}
        baseUrl={baseUrl}
        trainingId={trainingId}
      />
    );
  }

  if (libraryCategory === "Icons") {
    return (
      <IconsPanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        fileModalResult={fileModalResult}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  if (libraryCategory === "Animations") {
    return (
      <AnimationsPanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        fileModalResult={fileModalResult}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  if (libraryCategory === "Characters") {
    return (
      <CharactersPanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        fileModalResult={fileModalResult}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={handleReplaceSelected}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  if (libraryCategory === "Youtube") {
    return (
      <YoutubePanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={() => {}}
        onClose={onReturnToLayers}
      />
    );
  }

  if (libraryCategory === "Flickr") {
    return (
      <FlickrPanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={() => {}}
      />
    );
  }

  if (libraryCategory === "Europeana") {
    return (
      <EuropeanaPanel
        boxes={boxes}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        boxSelected={boxSelected}
        pluginToolbars={pluginToolbars}
        onBoxAdded={handleAddBoxAndClose}
        onElementSelected={() => {}}
      />
    );
  }

  return null;
};

LibraryPanels.propTypes = {
  libraryCategory: PropTypes.string,
  isClm: PropTypes.bool,
  aiPanel: PropTypes.string,
  filesUploaded: PropTypes.array,
  uploadFunction: PropTypes.func.isRequired,
  onNavItemsAdded: PropTypes.func.isRequired,
  onIndexSelected: PropTypes.func.isRequired,
  onNavItemSelected: PropTypes.func.isRequired,
  navItemsIds: PropTypes.array.isRequired,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  boxes: PropTypes.object.isRequired,
  boxSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pluginToolbars: PropTypes.object.isRequired,
  fileModalResult: PropTypes.object,
  onAddBox: PropTypes.func.isRequired,
  onReturnToLayers: PropTypes.func.isRequired,
  onSetLibraryCategory: PropTypes.func.isRequired,
  onReplacePluginFile: PropTypes.func.isRequired,
  onShowServerModal: PropTypes.func.isRequired,
  ttiGenerateImageFile: PropTypes.func.isRequired,
  ttsGenerateSoundFile: PropTypes.func.isRequired,
  baseUrl: PropTypes.string,
  trainingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onNarrationSelect: PropTypes.func,
  onNarrationDelete: PropTypes.func,
  onSceneOpen: PropTypes.func,
  onBoxAdded: PropTypes.func,
};

export default LibraryPanels;
